<app-navbar></app-navbar>

<div class="min-h-screen bg-section pt-24 pb-12 px-4 sm:px-6 lg:px-8 font-serif text-body-text selection:bg-btn/30 relative overflow-hidden">
  
  <!-- Botanical Decoration (Top Left) -->
  <div class="absolute -top-6 -left-6 sm:-top-12 sm:-left-12 w-32 h-32 sm:w-64 sm:h-64 md:w-96 md:h-96 opacity-40 sm:opacity-60 pointer-events-none z-0">
    <img src="amla-top-left.jpg" alt="Amla Branch" class="w-full h-full object-contain mix-blend-multiply aspect-square transform -rotate-12">
  </div>

  <!-- Botanical Decoration (Bottom Right) -->
  <div class="absolute -bottom-6 -right-6 sm:-bottom-12 sm:-right-12 w-40 h-40 sm:w-80 sm:h-80 md:w-[30rem] md:h-[30rem] opacity-40 sm:opacity-60 pointer-events-none z-0">
     <img src="amla-bottom-right.png" alt="Ashwagandha Root" class="w-full h-full object-contain mix-blend-multiply aspect-square transform rotate-12">
  </div>

  <div class="max-w-7xl mx-auto relative z-10">
    <!-- Empty State -->
    <div *ngIf="totalItems === 0" class="text-center py-20 space-y-6 animate-fade-in border border-[#E5E0D5] bg-white rounded-sm p-12">
      <div class="w-20 h-20 mx-auto border border-btn rounded-full flex items-center justify-center bg-card">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8 text-btn">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
        </svg>
      </div>
      <h2 class="text-2xl font-serif text-heading">Your cart is empty</h2>
      <p class="text-muted">Looks like you haven't added any botanical treasures yet.</p>
      <a routerLink="/" class="inline-block px-8 py-3 bg-heading text-white font-serif uppercase text-xs tracking-widest hover:bg-heading-dark transition-colors rounded-sm">
        Explore Products
      </a>
    </div>

    <!-- Cart Content -->
    <div *ngIf="totalItems > 0" class="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
      
      <!-- Cart Items List -->
      <div class="lg:col-span-8 space-y-6">
        <div class="bg-white border border-[#E5E0D5] rounded-sm overflow-hidden animate-fade-in-up">
          <ul class="divide-y divide-[#E5E0D5]">
            <li *ngFor="let item of cartItems; let i = index" class="p-6 flex flex-col sm:flex-row gap-6 hover:bg-[#FDFBF7]/50 transition-colors animate-fade-in-up" [style.animationDelay]="i * 100 + 'ms'">
              <!-- Image -->
              <div class="w-full sm:w-32 aspect-square bg-card flex-shrink-0 overflow-hidden rounded-sm border border-[#E5E0D5] shimmer">
                <img 
                  [src]="getImageUrl(item.product.image)" 
                  [alt]="item.product.name" 
                  loading="lazy"
                  class="w-full h-full object-cover object-center"
                >
              </div>

              <!-- Details -->
              <div class="flex-1 flex flex-col justify-between">
                <div>
                  <div class="flex justify-between items-start">
                    <div>
                      <p class="text-xs text-muted font-serif uppercase tracking-widest mb-1">{{ item.product.category }}</p>
                      <h3 class="text-lg font-serif text-heading cursor-pointer hover:text-btn transition-colors" [routerLink]="['/product', item.product.id]">
                        {{ item.product.name }}
                      </h3>
                    </div>
                    <div class="text-right">
                      <p class="font-bold text-heading text-lg">{{ getDiscountedPrice(item.product) | currency:'INR' }}</p>
                      <div *ngIf="item.product.discount" class="text-sm text-muted">
                        <span class="line-through decoration-btn/50">{{ item.product.price | currency:'INR' }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex flex-wrap items-center justify-between gap-4 mt-4">
                  <!-- Quantity -->
                  <div class="flex items-center gap-3">
                    <label class="text-xs uppercase tracking-wider text-muted">Quantity</label>
                    <select 
                      [(ngModel)]="item.quantity" 
                      (change)="updateQuantity(item.product.id, item.quantity)"
                      class="form-select pl-3 pr-8 py-1 border border-[#E5E0D5] text-heading text-sm focus:border-btn focus:ring-0 rounded-sm bg-white cursor-pointer"
                    >
                      <option *ngFor="let qty of [1,2,3,4,5,6,7,8,9,10]" [value]="qty">
                        {{ qty }}
                      </option>
                    </select>
                  </div>

                  <!-- Actions -->
                  <button 
                    (click)="removeItem(item.product.id)"
                    class="text-xs text-red-800 hover:text-red-600 uppercase tracking-widest transition-colors flex items-center gap-1 group"
                  >
                    <span>Remove</span>
                    <span class="block w-0 group-hover:w-full h-px bg-red-600 transition-all duration-300"></span>
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
        
        <div class="flex justify-start">
            <a routerLink="/" class="text-heading hover:text-btn font-serif text-sm flex items-center gap-2 transition-colors">
                <span>←</span> Continue Shopping
            </a>
        </div>
      </div>

      <!-- Order Summary -->
      <div class="lg:col-span-4">
        <div class="bg-white border border-[#E5E0D5] rounded-sm p-6 sticky top-24 shadow-sm">
          <h2 class="text-xl font-serif text-heading mb-6 pb-4 border-b border-[#E5E0D5]">Order Summary</h2>
          
          <div class="space-y-4 text-sm text-body-text">
            <div class="flex justify-between">
              <span class="text-muted">Subtotal ({{ totalItems }} items)</span>
              <span>{{ subtotal | currency:'INR' }}</span>
            </div>
            
            <div class="flex justify-between" *ngIf="getTotalSavings() > 0">
              <span class="text-muted">You Save</span>
              <span class="text-btn">-{{ getTotalSavings() | currency:'INR' }}</span>
            </div>
            
            <!-- Free Shipping Progress -->
            <div class="text-xs text-center py-2 px-3 rounded-sm"
                 [class.bg-green-50]="subtotal >= 499"
                 [class.text-green-700]="subtotal >= 499"
                 [class.bg-[#E5DDD5]/30]="subtotal < 499"
                 [class.text-muted]="subtotal < 499">
              <ng-container *ngIf="subtotal >= 499">
                🎉 You've unlocked <strong>FREE SHIPPING</strong>!
              </ng-container>
              <ng-container *ngIf="subtotal < 499">
                Add <strong>{{ (499 - subtotal) | currency:'INR':'symbol':'1.0-0' }}</strong> more for <strong>FREE SHIPPING</strong>
              </ng-container>
            </div>

            <div class="flex justify-between text-muted">
              <span>Shipping</span>
              <span *ngIf="subtotal >= 499" class="text-green-600 font-medium">FREE</span>
              <span *ngIf="subtotal < 499">₹49</span>
            </div>

            <div class="pt-4 border-t border-[#E5E0D5] flex justify-between items-center">
              <span class="font-bold text-lg text-heading">Total</span>
              <span class="font-bold text-lg text-heading">{{ grandTotal | currency:'INR' }}</span>
            </div>
          </div>

          <button 
            routerLink="/checkout"
            class="w-full mt-6 py-3 bg-btn text-white font-serif uppercase text-xs tracking-widest hover:bg-btn-hover transition-all duration-300 rounded-sm shadow-md disabled:opacity-50 disabled:grayscale"
          >
            Refine & Checkout
          </button>
          
          <p class="mt-4 text-[10px] text-muted text-center leading-relaxed">
            By proceeding, you agree to our Terms of Use and Privacy Policy.
          </p>
        </div>
      </div>
    
    </div>
  </div>
</div>
